import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import type { Article, Category } from "@/types/content";

export function getAllArticles(): Article[] {
  return articles;
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((item) => item.id === id);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((item) => item.category === slug);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((item) => item.featured);
}

export function getTrendingArticles(limit = 6): Article[] {
  return [...articles]
    .sort((a, b) => b.heat - a.heat)
    .slice(0, limit);
}

export function getLatestArticles(limit = 8): Article[] {
  return [...articles]
    .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1))
    .slice(0, limit);
}

export function getRelatedArticles(article: Article, limit = 3): Article[] {
  const sameCategory = articles.filter(
    (item) => item.id !== article.id && item.category === article.category,
  );
  const sharedTag = articles.filter(
    (item) =>
      item.id !== article.id &&
      item.category !== article.category &&
      item.tags.some((tag) => article.tags.includes(tag)),
  );
  return [...sameCategory, ...sharedTag].slice(0, limit);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((item) => item.slug === slug);
}

export function getCategoryName(slug: string): string {
  return getCategoryBySlug(slug)?.name ?? "瓜田";
}

export function searchArticles(keyword: string): Article[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return articles.filter((item) =>
    [item.title, item.excerpt, item.category, ...item.tags]
      .join(" ")
      .toLowerCase()
      .includes(key),
  );
}

export function getPopularArticles(limit = 5): Article[] {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getArticleNeighbors(id: string): {
  prev?: Article;
  next?: Article;
} {
  const sorted = [...articles].sort((a, b) =>
    a.publishedAt < b.publishedAt ? 1 : -1,
  );
  const index = sorted.findIndex((item) => item.id === id);
  if (index === -1) return {};
  return {
    prev: sorted[index + 1],
    next: sorted[index - 1],
  };
}

export function formatViews(value: number): string {
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return String(value);
}